// Curricula selectable in the internal admin panel: the shared list from
// boards.js plus legacy curricula that only the admin panel exposes.
import { CURRICULA as SHARED_CURRICULA } from "./boards";

const ADMIN_ONLY_CURRICULA = ["nyssls", "page"];

export const ADMIN_CURRICULA = Object.freeze([
  ...new Set([...SHARED_CURRICULA, ...ADMIN_ONLY_CURRICULA]),
]);
